<template>
    <div>
        <app-text
            label="Projektname"
            :data-source="'deha.user.misc.references.' + listitemId + '.data.name'"
            :data-default="{ type: 'raw', value: 'Ihr Projekt' }"
            required
            :maxlength="255"
        ></app-text>

        <app-wysiwyg
            label="Projektbeschreibung"
            :data-source="'deha.user.misc.references.' + listitemId + '.data.profile'"
            :data-default="{ type: 'textpicker' }"
            textpicker-namespace="references/profile"
            :maxlength="1024"
        ></app-wysiwyg>

        <app-select
            label="Ausführungsdatum Monat"
            :data-source="'deha.user.misc.references.' + listitemId + '.data.date_month'"
            :data-default="{ type: 'raw', value: new Date().getMonth() + 1 }"
            :options="getMonths"
        ></app-select>

        <app-select
            label="Ausführungsdatum Jahr"
            :data-source="'deha.user.misc.references.' + listitemId + '.data.date_year'"
            :data-default="{ type: 'raw', value: new Date().getFullYear() }"
            :options="getYears"
        ></app-select>

        <app-select
            label="Kategorie"
            :data-source="'deha.user.misc.references.' + listitemId + '.data.category'"
            :options="getOptions"
        ></app-select>

        <app-filepickers
            label="Bild"
            :data-source="'deha.user.misc.references.' + listitemId + '.data.images'"
            :data-default="{ type: 'file' }"
            file-namespace="images/references/default"
            accept=".jpg,.png,.gif"
            :max-count="4"
        ></app-filepickers>

        <app-link
            label="Button 1"
            :data-source="'deha.user.misc.references.' + listitemId + '.data.link'"
        ></app-link>

        <app-link
            label="Button 2"
            :data-source="'deha.user.misc.references.' + listitemId + '.data.link2'"
        ></app-link>

        <app-link
            label="Button 3"
            :data-source="'deha.user.misc.references.' + listitemId + '.data.link3'"
        ></app-link>
    </div>
</template>

<script>
import { toArray } from '@/helpers/utils';
import { mapGetters } from 'vuex';
import Text from '@/components/fields/simple/Text.vue';
import Wysiwyg from '@/components/fields/simple/Wysiwyg.vue';
import Select from '@/components/fields/simple/Select.vue';
import Filepickers from '@/components/assorted/Filepickers.vue';
import Link from '@/components/assorted/Link.vue';

export default {
    data() {
        return {};
    },
    methods: {},
    computed: {
        ...mapGetters(['getProp']),
        getMonths() {
            return {
                1: 'Januar',
                2: 'Februar',
                3: 'März',
                4: 'April',
                5: 'Mai',
                6: 'Juni',
                7: 'Juli',
                8: 'August',
                9: 'September',
                10: 'Oktober',
                11: 'November',
                12: 'Dezember'
            };
        },
        getYears() {
            let years = [],
                year = new Date().getFullYear();
            for (let i = 0; i < 50; i++) {
                years.push(year);
                year--;
            }
            return years;
        },
        getOptions() {
            return toArray(this.getProp('Listpresets.sectors'))
                .sort((a, b) => a.pos - b.pos)
                .map((i) => i.data().name);
        }
    },
    mounted() {
        this.$emit('controlhead', {
            title: this.$helpers.uiText('R043'),
            help: this.$helpers.uiText('R044'),
            removeText: this.$helpers.uiText('R045')
        });
    },
    props: {
        moduleId: String,
        listitemId: String
    },
    components: {
        'app-text': Text,
        'app-wysiwyg': Wysiwyg,
        'app-select': Select,
        'app-filepickers': Filepickers,
        'app-link': Link
    }
};
</script>
